<div class="modal" data-iframe-size>
  <div class="icon">
    <img [src]="warningUrl">
  </div>
  <h4 class="title">
    {{ 'i18n.dialog.productChooserWarning.title' |
       translate:undefined:{ productVariant: productVariant } }}
  </h4>

  <mat-dialog-content>
    <div class="content">
      {{ 'i18n.dialog.productChooserWarning.message' |
         translate:undefined: { productVariant: productVariant } }}</div>
  </mat-dialog-content>

  <dialog-buttons [buttons]="buttons" [stacked]="true"></dialog-buttons>
</div>
